import { Shapes } from '@components/shapes';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { Color, Font } from '@styles/theme';

type Variant =
  | 'success'
  | 'pending'
  | 'error'
  | 'info'
  | 'active'
  | 'skipped'
  | 'default'
  | 'disabled';

const variantColorMap: { [key in Variant]: Color } = {
  success: 'elementGreen200',
  pending: 'elementOrange100',
  error: 'elementRed100',
  info: 'elementIndigo100',
  active: 'elementBlue100',
  skipped: 'elementTeal100',
  default: 'elementPurple100',
  disabled: 'elementPurple50',
};

type Size = 'small' | 'medium';

const sizeFontMap: { [key in Size]: Font } = {
  small: 'semibold12',
  medium: 'semibold14',
};

export type TextStatusIndicatorProps = {
  variant?: Variant;
  text?: string | string[];
  size?: Size;
};

export const TextStatusIndicator = ({
  variant = 'default',
  text,
  size = 'medium',
}: TextStatusIndicatorProps) => {
  const color = variantColorMap[variant];
  const font = sizeFontMap[size];
  return (
    <Stack orientation="horizontal" space={2} align="center">
      <Shapes.Circle size={8} color={color} />
      <Text text={text} color={color} font={font} />
    </Stack>
  );
};
